<template>
  <div>
    <Navbar v-if="!isShare" title="" :backNative="isApp"></Navbar>

    <van-pull-refresh
      v-model="refreshing"
      style="min-height: 100vh"
      @refresh="onRefresh"
    >
      <div class="detailMain">
        <div class="userInfo">
          <div class="avater-box">
            <div class="avater">
              <img
                @click="toUser(detail.memberId)"
                :src="
                  detail.memberAvatar
                    ? detail.memberAvatar
                    : require('../../assets/images/default.png')
                "
                width="100%"
                alt=""
              />
            </div>
            <div class="nameAndDate">
              <div class="name">{{ detail.memberName }}</div>
              <div class="date">{{ detail.releaseDate }}</div>
            </div>
          </div>
          <div class="options" v-if="detail.workType == 1">
            <img
              src="../../assets/images/options.png"
              alt=""
              @click="
                openReport(detail.workId, detail.memberName, detail.title)
              "
            />
          </div>
          <div class="learned" v-else>
            已学习 <span>{{ obj.studyTime }}</span> 天
          </div>
        </div>
        <div class="content">
          <div class="text" style="white-space: pre-line">
            {{ detail.title }}
          </div>
          <div class="photoOrVedio">
            <div class="videoInfo" v-if="detail.video">
              <video
                :src="detail.video"
                :poster="detail.image"
                controls
              ></video>
              <!-- <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"
              >
              </video-player> -->
            </div>
            <div class="photoBox" v-else>
              <div
                class="photo"
                v-for="(item, index) in images"
                :key="index"
                :style="{
                  background: 'url(' + item + ') no-repeat center center',
                  'background-size': '100%',
                }"
                @click="imageWatch(index)"
              ></div>
            </div>
          </div>
          <div class="likeNumber">
            <span>{{ detail.workType == "1" ? "动态" : "作业" }}</span>
            <span class="center">丨</span>
            <span>获赞{{ detail.praise }}</span>
            <span class="center">丨</span>
            <span>评论{{ detail.commentNum }}</span>
          </div>
        </div>
      </div>
      <div class="analyse" v-if="obj.classesTypeId === 0">
        <div class="analyse_title">完整分析</div>

        <div class="analyse_list">
          <div class="analyse_card">
            <div>完整度</div>
            <div v-if="obj.integrity == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.integrity == 1
                  ? require('../../assets/images/pass.png')
                  : obj.integrity == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>和弦</div>
            <div v-if="obj.chord == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.chord == 1
                  ? require('../../assets/images/pass.png')
                  : obj.chord == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>熟练度</div>
            <div v-if="obj.skilled == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.skilled == 1
                  ? require('../../assets/images/pass.png')
                  : obj.skilled == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>指法</div>
            <div v-if="obj.fingering == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.fingering == 1
                  ? require('../../assets/images/pass.png')
                  : obj.fingering == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>节奏</div>
            <div v-if="obj.rhythm == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.rhythm == 1
                  ? require('../../assets/images/pass.png')
                  : obj.rhythm == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>手型</div>
            <div v-if="obj.handshape == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.handshape == 1
                  ? require('../../assets/images/pass.png')
                  : obj.handshape == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 教师点评 -->
      <div class="teacherComment" v-if="isPass != 0">
        <img
          class="commentIcon"
          src="../../assets/images/commentIcon.png"
          alt=""
        />
        <div class="comment_word">{{ obj.teacherReview }}</div>

        <div class="picsList" v-if="obj.teacherPicture.length > 0">
          <div
            class="picItem"
            v-for="(items, index) in obj.teacherPicture"
            @click="watchPic(index)"
            :key="index"
            :style="{
              background:
                'url(' +
                obj.teacherPicture[index] +
                ') no-repeat center center',
              backgroundSize: '100% auto',
            }"
          ></div>
        </div>

        <div class="line"></div>

        <div class="teacherAvatar">
          <img
            :src="
              detail.teacherAvatar
                ? obj.teacherAvatar
                : require('../../assets/images/default.png')
            "
            alt=""
          />
          <div>{{ obj.teacherName }}</div>
        </div>
      </div>
      <!-- banner板块 -->

      <div class="workbanner" v-if="detail.workType == 0 && !showBanner">
        <div class="my-swipe">
          <div class="avater">
            <img src="../../assets/images/pic1.png" alt="" />
            <span>重点班</span>
          </div>
          <div class="joinText">
            <p style="font-weight: bold; font-size: 15px; margin: 0">
              来自{{ this.detail.memberName }}同学的邀请
            </p>
            <p style="margin: 0; margin-top: 3px">
              {{ this.userName }}同学，愿意加入一起学习吗
            </p>
          </div>
          <div class="joinButton">
            <van-button
              @click="skipBanner()"
              type="primary"
              color="black"
              size="small"
              >加 入</van-button
            >
          </div>
        </div>
      </div>
      <div class="banner" v-else-if="detail.workType == 1">
        <van-swipe :autoplay="5000" class="my-swipe" indicator-color="white">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index">
            <img
              @click="dynamicBanner(item)"
              :src="item.coverPicture"
              width="390px"
              height="80px"
              alt=""
            />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="comments" v-if="!this.isShare">
        <div class="comment_title">
          评论<span>{{ detail.commentNum }}</span>
        </div>

        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <div class="commentBox">
            <div
              class="items"
              v-for="(item, index) in commentList"
              :key="index"
            >
              <div class="avater">
                <img
                  @click="toUser(item)"
                  :src="
                    item.avatar != null && item.avatar != ''
                      ? item.avatar
                      : require('../../assets/images/default.png')
                  "
                  alt=""
                />
              </div>
              <div class="content">
                <div class="topBox">
                  <div class="name">{{ item.name }}</div>
                  <div class="options">
                    <img
                      src="../../assets/images/options.png"
                      alt=""
                      @click="
                        openReport(item.memberWorkId, item.name, item.content)
                      "
                    />
                  </div>
                </div>
                <div
                  class="text"
                  @click="replyOtherUser(item.workId, item.memberId)"
                >
                  {{ item.content }}
                </div>
                <div class="time">{{ item.releaseTime }}</div>

                <div class="childReply">
                  <div
                    class="childItems"
                    v-for="(childItem, childIndex) in item.workCommentList"
                    :key="childIndex"
                  >
                    <div class="topBox">
                      <div class="topLeft">
                        <div class="childAvater" style="">
                          <img
                            @click="toUser(item.workCommentList[0])"
                            :src="
                              childItem.avatar != null && childItem.avatar != ''
                                ? childItem.avatar
                                : require('../../assets/images/default.png')
                            "
                            alt=""
                          />
                        </div>

                        <div class="replyUsers">
                          <div class="beforeUser">
                            {{ childItem.memberName }}
                          </div>
                          <span>回复</span>
                          <div class="afterUser">
                            {{ childItem.replyCName }}
                          </div>
                        </div>
                      </div>
                      <div class="topRight">
                        <img
                          src="../../assets/images/options.png"
                          alt=""
                          @click="
                            openReport(
                              childItem.workId,
                              childItem.memberName,
                              childItem.content
                            )
                          "
                        />
                      </div>
                    </div>
                    <div
                      class="childText"
                      @click="replyOtherUser(item.workId, childItem.memberId)"
                    >
                      {{ childItem.content }}
                    </div>
                    <div class="childTime">{{ childItem.releaseTime }}</div>
                  </div>
                  <div
                    class="more"
                    v-if="item.workCommentSize != 0 && !item.hideMore"
                  >
                    <span @click="getMore(item.workId)"
                      >更多{{ item.workCommentSize }}条回复</span
                    >
                    <div class="moreIcon">
                      <img src="../../assets/images/row_down.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </van-pull-refresh>

    <div class="bottomInput" v-if="!this.isShare">
      <van-field
        ref="commentInput"
        v-model="commentValue"
        @focus="inputHasFocus"
        type="textarea"
        rows="1"
        autosize
        @blur="inputNotFocus"
        placeholder="说说你的看法"
      />

      <div class="rightBox" v-if="!inputFocus && !isShare">
        <div class="share" @click="shareShow">
          <img src="../../assets/images/share.png" width="20px" alt="" />
          <span>分享</span>
        </div>
        <div class="giveLike" @click="giveLike">
          <img
            :src="
              like === 1
                ? require('../../assets/images/parise_act.png')
                : require('../../assets/images/parise.png')
            "
            width="20px"
            alt=""
          />
          <span :style="{ color: like === 1 ? '#FC541E' : '#222030' }">{{
            detail.praise
          }}</span>
        </div>
      </div>

      <div class="rightBox" v-if="inputFocus && !isShare">
        <van-button type="warning" @click="toSend">发送</van-button>
      </div>
    </div>

    <!-- <div class="sendInput" v-if="inputFocus && !isShare">
      <van-field
        @focus="inputFocusMethods"
        v-model="commentValue"
        @blur="inputNotFocus"
        placeholder="说说你的看法"
      />

      
    </div> -->

    <van-action-sheet
      v-model="reportShow"
      :actions="[{ name: '举报' }]"
      cancel-text="取消"
      close-on-click-action
      @cancel="closeReport"
      @select="selectReport"
    />

    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '158px' }"
    >
      <div class="pop_title">分享到</div>
      <div class="icons">
        <div class="icon_item" @click="toWechat">
          <img src="../../assets/images/wechat.png" alt="" />
          <span>微信</span>
        </div>

        <div class="icon_item" @click="toFriendCircle">
          <img src="../../assets/images/friendCircle.png" alt="" />
          <span>朋友圈</span>
        </div>

        <div class="icon_item" @click="toQQ">
          <img src="../../assets/images/qq.png" alt="" />
          <span>QQ</span>
        </div>
      </div>
    </van-popup>
    <LikeModal
      v-if="likeModalFlag"
      @closeModal="setLikeModal(false)"
      @giveLikeCallBack="successGiveLike"
    ></LikeModal>
  </div>
</template> 
 
<script>
import Navbar from "../../components/NavBar";
import LikeModal from "./LikeModal.vue";
import { ImagePreview, Notify, Toast } from "vant";
import http from "../../utils/http";

export default {
  name: "",
  components: {
    Navbar,
    LikeModal,
  },
  data() {
    return {
      detail: {}, // 详情
      like: 0, // 当前用户是否点赞
      talkList: [], // 评论列表
      bannerList: [], //广告列表
      commentValue: "", // 评论输入框值
      inputFocus: false, //评论输入框是否聚焦
      images: [], // 九宫格图片
      // likeModal: false, // 点赞确认的模态框
      likeModalFlag: false, // 控制点赞模态框的开关
      list: [],
      commentType: 0, // 判断是回复用户还是回复文章
      replyMemberId: "", // 被回复的人的id
      parentId: "", // 回复别人的评论时，一级评论的id
      commentList: [], //回复列表
      isShare: false, // 是否是分享页
      show: false, //分享弹框
      refreshing: false, //是否正在刷新
      reportShow: false, // 举报flag
      size: 20,
      current: 1,
      userName: "",
      loading: false,
      finished: false,
      reportId: "", // 被举报的id
      reportText: "", //被举报的内容
      workId: "",
      isApp: false,
      isPass: "", //是否通过审核
      obj: [],
      showBanner: false,
      userId: "",
      dialogShow: false,//弹出框
      shareContent: "",//分享文案
      shareFlag: "",
    };
  },
  // created(){
  //   this.getDetail()
  // },
  methods: {
    initPage() {
      this.getDetail();
      this.getuserName();
    },
    onLoad() {
      if (this.refreshing) {
      } else {
        this.current++;
      }
      this.getDetail();
    },
    skipBanner() {
      http.guitarBannerListener("skipBanner", {
        params: "",
      });
    },
    dynamicBanner(params) {
      http.guitarAppListener("dynamicBanner", {
        courseId: params.courseId,
        courseType: params.courseType,
        coverPicture: params.coverPicture,
        createDate: params.createDate,
        dataId: params.dataId,
        delFlag: params.delFlag,
        id: params.id,
        skipType: params.skipType,
        sort: params.sort,
        type: params.type,
        updateDate: params.updateDate,
      });
    },
    toUser(params) {
      if (params.memberId) {
        http.guitarAppListener("toUser", {
          memberId: params.memberId,
        });
      } else {
        http.guitarAppListener("toUser", {
          memberId: params,
        });
      }
    },
    selectReport(e) {
      if (e.name == "举报") {
        this.report();
      }
    },
    closeReport() {
      this.reportId = "";
      this.reportText = "";
    },
    openReport(workId, _name, text) {
      this.reportId = workId;
      this.reportText = `${_name} 的帖子： ${text}`;
      this.reportShow = true;
    },
    onRefresh() {
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = false;
      this.current = 1;
      this.onLoad();
    },
    getMore(id) {
      // 获取更多的评论
      let params = {};
      params.commentId = id;
      http.getMoreComment(params).then((res) => {
        if (res) {
          this.commentList.map((item, index) => {
            if (item.workId == id) {
              item.workCommentList.push(...res);
              item.hideMore = true;
              // this.commentList[index] = item
            }
          });
        }
      });
    },
    shareShow() {
      this.show = true;
    },
    report() {
      http.guitarAppListener("report", {
        id: this.reportId,
        text: this.reportText,
      });
    },
    toWechat() {
      let query = this.$route.query;
      let params = {};
      params.path = `/sharePage?id=${query.id}`;
      params.img = this.detail.image ? this.detail.image : "";
      params.title = this.detail.homeworkCopy ? this.detail.homeworkCopy : "";
      http.guitarAppListener("toWechat", {
        path: `/sharePage?id=${query.id}`,
        img: this.detail.image,
        title: this.detail.memberName,
        content: this.detail.title?this.detail.title:"我的动态更新了，快来围观吧",
      });
    },
    toFriendCircle() {
      let query = this.$route.query;
      let params = {};
      params.path = `/sharePage?id=${query.id}`;
      params.img = this.detail.image ? this.detail.image : "";
      http.guitarAppListener("toFriendCircle", {
        path: `/sharePage?id=${query.id}`,
        img: this.detail.image,
        title: `${this.detail.memberName}发布了一条新动态`,
        content: this.detail.title?this.detail.title:"我的动态更新了，快来围观吧",
      });
    },
    toQQ() {
      let query = this.$route.query;
      let params = {};
      params.path = `/sharePage?id=${query.id}`;
      params.img = this.detail.image ? this.detail.image : "";
      http.guitarAppListener("toQQ", {
        path: `/sharePage?id=${query.id}`,
        img: this.detail.image,
        title: `${this.detail.memberName}发布了一条新动态`,
        content: this.detail.title?this.detail.title:"我的动态更新了，快来围观吧",
      });
    },
    // 点击图片展示大图
    imageWatch(index) {
      ImagePreview({
        images: this.images,
        startPosition: index,
        loop: false,
      });
    },

    // 输入框聚焦
    inputHasFocus() {
      // this.commentType = 0;
      // this.inputFocus = true;
      if (this.replyMemberId && this.parentId) {
        this.commentType = 1;
      }
      this.inputFocus = true;
    },

    // 输入框失焦
    inputNotFocus() {
      setTimeout(() => {
        this.inputFocus = false;
        this.replyMemberId = "";
        this.parentId = "";
        this.commentType = 0;
      }, 200);
    },

    //关闭或者开启点赞模态框
    setLikeModal(flag) {
      // console.log(likeModalFlag);
      this.likeModalFlag = flag;
    },

    replyOtherUser(parentId, id) {
      //回复别人
      this.commentType = 1;
      this.replyMemberId = id;
      this.parentId = parentId;
      this.$refs.commentInput.focus();
    },

    // 点击点赞
    giveLike() {
      let flag = localStorage.getItem("likeTips");
      if (this.like === 1) {
        return;
      }
      if (flag) {
        http
          .giveALike({ dataId: this.$route.query.id, type: 2 })
          .then((res) => {
            Toast("送花成功");
            this.like = 1;
            this.detail.praise = ++this.detail.praise;
          });
        return;
      }
      this.setLikeModal(true);
    },

    // 点赞完成之后手动修改点赞按钮的状态和其他方法的回调
    successGiveLike(flag) {
      http.giveALike({ dataId: this.$route.query.id, type: 2 }).then((res) => {
        if (res) {
          if (flag) {
            localStorage.setItem("likeTips", "1");
          }
          Toast("送花成功");
          this.likeModalFlag = false;
          this.like = 1;
          this.detail.praise = ++this.detail.praise;
        }
      });
    },

    //聚焦
    // inputFocusMethods() {
    //   this.commentType = 0;
    //   this.inputFoucus = true;
    //   console.log(this.commentType)
    // },
    getuserName() {
      http.getUserInfo().then((res) => {
        this.userId = res.id;
        this.userName = res.name;
      });
    },
    getDetail() {
      http
        .getMenberDetail({
          size: this.size,
          current: this.current,
          workId: this.$route.query.id,
        })
        .then((res) => {
          this.refreshing = false;
          // console.log(res);
          this.detail = res.communityWorkVo; // 详情
          this.like = res.giveALike; // 当前用户是否点赞
          this.bannerList = res.bannerList; //广告列表
          // this.playerOptions.poster = this.detail.image; //视频封面
          // this.playerOptions["sources"][0]["src"] = this.detail.video; //视频路径
          if (!res.communityWorkVo.video) {
            if (res.communityWorkVo.image) {
              let imgList = res.communityWorkVo.image.split(",");
              this.images = imgList;
            }
          }
          if (this.detail.workType == 0) {
            http
              .getMemberWorkVO({
                classType: this.$route.query.classType,
                MemberWorkId: this.$route.query.id,
              })
              .then((res) => {
                this.isPass = res.status;
                this.obj = res;
                if (res.teacherPicture) {
                  this.obj.teacherPicture = res.teacherPicture.split(",");
                } else {
                  this.obj.teacherPicture = [];
                }
              });
          }
          setTimeout(() => {
            if (res.workMemberCommentVOList.length > 0) {
              if (this.refreshing || this.current == 1) {
                this.commentList = [...res.workMemberCommentVOList];
                this.refreshing = false;
              } else {
                this.commentList = [
                  ...this.commentList,
                  ...res.workMemberCommentVOList,
                ];
              }

              this.loading = false;
            } else {
              this.finished = true;
              this.refreshing = false;
              this.current--;
            }
          }, 500);

          // this.commentList = res.workMemberCommentVOList;
        });
    },
    // 预览图片
    watchPic(index) {
      ImagePreview({
        images: this.obj.teacherPicture,
        startPosition: index,
        loop: false,
      });
    },
    toSend() {
      //发送评论
      if (this.commentValue.trim() == "") {
        Toast("评论内容不能为空");
        return false;
      }
      Toast.loading();
      let params = {};
      console.log(this.detail);
      params = {
        content: this.commentValue,
        memberWorkId: this.detail.id,
        authorId: this.detail.memberId,
        memberWorkId: this.detail.workId,
        workType: 1,
        commentType: this.commentType,
      };
      if (this.commentType == 1) {
        // 如果是回复别人的评论，加上两个参数
        params.replyMemberId = this.replyMemberId;
        params.parentId = this.parentId;
      }
      http.sendComment(params).then((res) => {
        this.commentValue = "";
        Toast("评论成功");
        this.current = 1;
        this.addCommand = true;
        this.getDetail();
        this.addCommand = false;
        this.inputFoucus = false;
        this.$refs.commentInput.blur();
      });
    },
  },
  // s
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  mounted() {
    if (this.$route.query.isShare) {
      this.isShare = this.$route.query.isShare;
    }
    if (this.$route.query.showBanner) {
      this.showBanner = this.$route.query.showBanner;
    }
    if (this.$route.query.isApp) {
      this.isApp = true;
    }
  },
};
</script>

<style scoped lang='less'>
.detailMain {
  border-bottom: 1px solid #f0f0f1;
  margin: 10px 16px;
  box-sizing: border-box;
  .userInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    .avater-box {
      display: flex;
    }
    .avater {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 12px;
    }
    .options {
      left: 0px;
      top: 0px;
      width: 14px;
      img {
        right: 10px;
        width: 100%;
      }
    }
    .nameAndDate {
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        color: #222;
        font-size: 15px;
        font-weight: 600;
      }
      .date {
        color: rgba(34, 32, 48, 0.45);
        font-size: 12px;
      }
    }
    .learned {
      color: #9b9aa2;
      font-size: 11px;
      span {
        font-size: 20px;
        color: #fc541e;
        font-weight: bold;
      }
    }
  }
  .content {
    .text {
      color: #222030;
      font-weight: 400;
      font-size: 15px;
      margin: 10px 0;
    }
    .photoOrVedio {
      margin-bottom: 14px;
      .photoBox {
        border-radius: 6px 6px 6px 6px;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        .photo {
          // background-color: red;
          overflow: hidden;
          width: calc(98% / 3);
          margin-right: 1%;
          &:nth-child(3n) {
            margin-right: 0;
          }
          margin-bottom: 1%;
          padding-top: 33%;
          // img {
          //   width: 100%;
          //   display: block;
          // }
        }
      }
      .videoInfo {
        width: 100%;
        margin: 0 auto;
        margin-top: 12px;
        video {
          width: 100%;
          height: 194px;
          border-radius: 10px;
          object-fit: cover;
        }
      }
    }
    .likeNumber {
      margin-bottom: 20px;
      span {
        font-size: 13px;
        color: rgba(34, 32, 48, 0.45);
        font-weight: 400;
      }
    }
  }
}
.workbanner {
  background-image: url(../../assets/images/banner.png);

  .my-swipe {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    height: 70px;
    margin: 0 auto;
    box-sizing: border-box;
    .avater {
      display: flex;
      flex-direction: column;
      width: 40px;
      height: 40px;
      margin-left: 12px;
      img {
        margin-left: 2px;
        width: 30px;
        height: 30px;
      }
    }
    .joinButton {
      right: 5px;
      border-radius: 20px;
      /deep/ van-button {
        border-radius: 15px;
      }
    }
  }
}

.bottomInput,
.sendInput {
  background-color: #fff;
  border-top: 1px solid #ebebed;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .van-button {
    height: 30px;
  }
  .van-field {
    // background-color: red;
    width: 70%;
  }
  .rightBox {
    width: 26.5%;
    background-color: #fff;
    // background-color: blue;
    display: flex;
    align-items: center;
    .share {
      height: 98%;
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #222030;
      // font-size: 8px;
      img {
        width: 22px;
        height: 22px;
      }
    }
    .giveLike {
      height: 98%;
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // font-size: 14px;
      img {
        width: 22px;
        height: 22px;
      }
    }
  }
}
.comments {
  padding-bottom: 60px;
  width: calc(100% - 32px);
  margin: 0 auto;
  margin-top: 24px;
  .comment_title {
    font-size: 20px;
    color: #222030;
    font-weight: 600;
    span {
      font-size: 18px;
      color: #9b9aa2;
    }
  }
}
.analyse {
  width: calc(100% - 32px);
  margin: 0 auto;
  margin-top: 22px;
  .analyse_title {
    font-size: 20px;
    font-weight: 600;
  }
  .analyse_list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 12px;
    .analyse_card {
      width: 167px;
      height: 40px;
      padding: 0 16px;
      box-sizing: border-box;
      background: #f6f6f6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      div {
        font-size: 15px;
        color: #222030;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .analyse_card:nth-child(odd) {
      border-radius: 6px 0px 0px 0px;
    }
    .analyse_card:nth-child(even) {
      border-radius: 0px 6px 0px 0px;
    }
  }
}
.teacherComment {
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
  background: #f6f6f6;
  border-radius: 6px;
  margin-bottom: 24px;
  .commentIcon {
    width: 60px;
    height: 15px;
  }
  .comment_word {
    font-size: 15px;
    color: #222030;
    margin-top: 18px;
  }
  .picsList {
    display: flex;
    margin-top: 12px;
    .picItem {
      width: 42px;
      margin-left: 3px;
      height: 42px;
      &:nth-of-type(1) {
        margin: 0;
      }
    }
  }

  .teacherAvatar {
    display: flex;
    align-items: center;
    margin-top: 8px;
    img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
    div {
      font-size: 12px;
      margin-left: 8px;
      color: #6c6b75;
    }
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #e1e1e3;
  margin-top: 12px;
}
.commentBox {
  .items {
    margin-top: 12px;
    display: flex;
    margin-bottom: 20px;
    .avater {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .content {
      flex: 1;
      margin-left: 8px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f4f4f5;
      overflow: hidden;
      .topBox {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        .name {
          font-size: 13px;
          color: #6f6e78;
        }
        .options {
          width: 14px;

          img {
            width: 100%;
          }
        }
      }
      .text {
        font-size: 14px;
        color: #222030;
        // max-width: 90%;
        word-wrap: break-word;
        margin-bottom: 8px;
      }
      .time {
        color: #9b9aa2;
        font-size: 11px;
      }

      .childReply {
        margin: 16px 0;
        width: 100%;
        .childItems {
          margin-bottom: 8px;
          width: 100%;
          &:nth-last-child(1) {
            margin: 0;
          }
          .topBox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .topLeft {
              display: flex;
              align-items: center;
              .childAvater {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                object-fit: cover;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  object-fit: cover;
                }
              }
              .replyUsers {
                margin-left: 4px;
                flex: 1;
                display: flex;
                font-size: 13px;
                color: #6f6e78;
                font-weight: 400;
                .beforeUser {
                  max-width: 100px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .afterUser {
                  max-width: 100px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                span {
                  white-space: nowrap;
                  color: #222030;
                  margin: 0px 4px;
                }
              }
            }
            .topRight {
              width: 14px;
              img {
                width: 100%;
              }
            }
          }
          .childText {
            font-size: 14px;
            color: #222030;
            font-weight: 400;
            margin: 8px 0;
          }
          .childTime {
            color: #9b9aa2;
            font-size: 11px;
          }
        }
        .more {
          display: flex;
          align-items: center;
          margin-top: 16px;
          span {
            font-size: 13px;
            color: #9b9aa2;
          }
          .moreIcon {
            margin-left: 4px;
            width: 10px;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
.banner {
  .my-swipe {
    width: 100%;
    height: 80px;
    text-align: center;
    // /deep/ img {
    // }
  }
}

.van-popup {
  .pop_title {
    text-align: center;
    font-size: 15px;
    color: #222030;
    margin-top: 16px;
  }
  .icons {
    width: calc(100% - 124px);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  .icon_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 52px;
      height: 52px;
    }
    span {
      display: inline-block;
      margin-top: 8px;
      font-size: 15px;
      color: #222030;
    }
  }
}
</style>